module.exports = __webpack_public_path__ + "img/prev-right.96b2d20c.svg";